const skillsGameEngine = [
    { text: 'Unity', icon: 'skill_professional.png'},
    { text: 'Unreal Engine 4', icon: 'skill_intermediate.png'},
    { text: 'Construct 2', icon: 'skill_intermediate.png'},
    { text: 'Godot', icon: 'skill_beginner.png'},
  ];
  
  export default skillsGameEngine;